import api from '../services/apiHub';
import getHeaders from '../utils/returnHeadersHub';

export default class DiscountRepository {
	validateDiscount = async (type, data) => {
		const headers = getHeaders();

		try {
			const response = await api.post(
				`/api/services/${type}/check-discount`,
				JSON.stringify(data),
				headers
			);
			if (!response?.data?.success) {
				throw new Error(response?.data?.error || 'Falha na validação do cupom');
			}
			return response.data || response;
		} catch (error) {
			throw error;
		}
	};
}
